module.exports = __webpack_public_path__ + "img/16.bdcace96.png";